import { APIHelper } from '@archistarai/auth-frontend';

export default {
  async getFormData() {
    return APIHelper.ManageAPI.post('filters/sites/form-data');
  }
};
